import React, { FC } from 'react';

interface IProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
}

export const ToggleSwitch: FC<IProps> = ({ value, onChange, label }) => {
  return (
    <div
      onClick={() => onChange(!value)}
      className={`flex items-center gap-3 px-3 py-2 rounded-lg border border-[#2B292F] transition-colors duration-300 
            bg-[#141316] cursor-pointer`}
    >
      <div
        className={`w-[34px] h-[14px] flex items-center rounded-full transition-colors duration-300
                    ${value ? 'bg-[#d7f52580]' : 'bg-[#211F24]'}`}
      >
        <div
          className={`w-[20px] h-[20px] rounded-full  shadow-md transform duration-300
                    ${value ? 'translate-x-5 bg-[#189CD8]' : '-translate-x-1 bg-[#696969]'}`}
        />
      </div>
      <span className="text-white">{label}</span>
    </div>
  );
};
